import React from 'react'
import Confetti from 'react-confetti'
import { useWindowSize } from 'react-use'

const ConfettiAnimation: React.FC = () => {
  const [pieces, setPieces] = React.useState(250)
  const { width, height } = useWindowSize()

  // React.useEffect(() => {
  //   const interval = setInterval(() => {
  //     setPieces((prevState) => (prevState >= 15 ? prevState - 15 : 0))
  //   }, 300)

  //   if (window.Telegram?.WebApp?.HapticFeedback) {
  //     window.Telegram.WebApp.HapticFeedback.impactOccurred('heavy')
  //     setTimeout(() => {
  //       window.Telegram.WebApp.HapticFeedback?.impactOccurred('heavy')
  //     }, 200)
  //     setTimeout(() => {
  //       window.Telegram.WebApp.HapticFeedback?.impactOccurred('heavy')
  //     }, 400)
  //   }

  //   return () => clearInterval(interval)
  // }, [])

  return <Confetti width={width} height={height} numberOfPieces={pieces} />
}

export default ConfettiAnimation
